import i18n from '@/lang/i18n';
import LayoutMain from '@/layouts/LayoutMain.vue';

export default [
  {
    name: 'Base',
    path: '/:locale',
    component: LayoutMain,
    // meta: { title: 'Контакты клиентов' },
    beforeEnter(to, _from, next) {
      const locale = to.params.locale;
      const supportedLocales = i18n.global.availableLocales;

      if (!supportedLocales.includes(locale)) {
        to.params.locale = 'en';

        return next(to);
      }

      if (i18n.locale !== locale) {
        i18n.global.locale = locale;
      }

      return next();
    },
    children: [
      {
        path: '',
        name: 'Control',
        component: () =>
          import(
            /* webpackChunkName: "control" */ '@/views/Control/Control.vue'
          ),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect() {
      return process.env.VUE_APP_DEFAULT_I18N_LOCALE;
    },
  },
];
